//
//
//
//
//

export default {
  props: {
    message: {
      type: String,
      default: 'Sin grupo',
    },
  },
}
